import React from 'react';
import './LanguageSwitcher.css';

interface LanguageSwitcherProps {
  language: 'ru' | 'kz';
  setLanguage: (lang: 'ru' | 'kz') => void;
}

function LanguageSwitcher({ language, setLanguage }: LanguageSwitcherProps) {
  return (
    <div className="language-switcher">
      <button
        className={`lang-button ${language === 'ru' ? 'active' : ''}`}
        onClick={() => setLanguage('ru')}
      >
        Русский
      </button>
      <button
        className={`lang-button ${language === 'kz' ? 'active' : ''}`}
        onClick={() => setLanguage('kz')}
      >
        Қазақша
      </button>
    </div>
  );
}

export default LanguageSwitcher; 